export const FooterDataStructure = [
  {
    route: "/",
    image: "/images/icons/home.svg",
    title: "Home",
  },
  {
    route: "/",
    image: "/images/icons/book.svg",
    title: "Docs",
  },
  {
    route: "/",
    image: "/images/icons/cube.svg",
    title: "Examples",
  },
  {
    route: "/",
    image: "/images/icons/tutorials.svg",
    title: "Themes",
  },
]
